import type { Cart } from "../components/Cart"

// Funnel attribution for checkout events: one ID per checkout entry, carried through payment to the
// return page after a redirect, and the event each cart line belongs to. localStorage, not
// sessionStorage: payment apps such as Swish return to a new tab.

const attemptKey = (code: string) => `werz:checkout-attempt:v1:${code}`

export function startCheckoutAttempt(code: string) {
  const checkoutId = crypto.randomUUID()
  try {
    localStorage.setItem(attemptKey(code), checkoutId)
  } catch {
    /* Storage can be unavailable; the payment events then carry no checkout ID. */
  }
  return checkoutId
}

export function checkoutAttemptId(code: string | undefined) {
  if (!code) return undefined
  try {
    return localStorage.getItem(attemptKey(code)) ?? undefined
  } catch {
    return undefined
  }
}

// The return page is reopened (a payment app returning again, a reload); report each purchase's
// success once per browser.
export function isFirstCheckoutSuccess(purchaseIds: string[]) {
  const key = `werz:checkout-success:v1:${[...purchaseIds].sort().join(";")}`
  try {
    if (localStorage.getItem(key)) return false
    localStorage.setItem(key, "1")
  } catch {
    /* Without storage a reopened return page reports again. */
  }
  return true
}

export const checkoutItems = (items: Cart[string] | undefined) =>
  Object.values(items ?? {})
    .filter(({ quantity }) => quantity > 0)
    .map(({ product, quantity }) => ({
      eventId: product.event?.id,
      productId: product.id,
      quantity,
    }))
